import React from 'react';
import type { SensorSelectRow } from '../sensorFormPayload';
import type { EditSensorsAndProducts } from '../useEditSensorsAndProducts';
import EditProductsSection from './EditProductsSection';
import SensorSection from './SensorSection';
import styles from './EditProductsAndSensors.module.css';

interface EditProductsAndSensorsProps {
  links: EditSensorsAndProducts;
  sensorsList: SensorSelectRow[];
  sensorOptions: React.ReactNode;
}

/** The edit drawer's Products grid and Sensors rows, each under a divider (spec UE2–UE5). */
const EditProductsAndSensors: React.FC<EditProductsAndSensorsProps> = ({
  links,
  sensorsList,
  sensorOptions,
}) => (
  <>
    <hr className={styles.rule} />
    <EditProductsSection
      rows={links.products.rows}
      lines={links.products.lines}
      onLinesChange={links.products.setLines}
      onProductIdsChange={links.changeShipmentProducts}
      getProductName={links.getProductName}
      catalog={links.catalog}
      readOnlyNote={links.productsNote}
      isLoading={links.products.isLoading}
      isError={links.products.isError}
      onRetry={links.products.retry}
    />
    <hr className={styles.rule} />
    <SensorSection
      rows={links.sensorRows}
      onRowsChange={links.changeSensorRows}
      sensorsList={sensorsList}
      getProductName={links.getProductName}
      renderProductPicker={(value, onChange) =>
        links.renderProductPicker(value, onChange, 'Sensor products')
      }
      onEditingChange={links.setSensorCardOpen}
      isSimulatorSensor={() => false}
      suggestSensorId={() => undefined}
      readOnly={sensorsList.length === 0}
    >
      {sensorOptions}
    </SensorSection>
  </>
);

export default EditProductsAndSensors;
